import { Delta } from 'quill';

import { CallState, LoadingState } from 'src/app/utilities/state.util';

export const newOpportunityAddInventoryInitialState = {
    inventoryText: new Delta() as Delta,
    callState: LoadingState.INIT as CallState,
};

export type NewOpportunityAddInventoryState = typeof newOpportunityAddInventoryInitialState;
